module.exports = "/static/assets/3ec61f503dec864677769aa41fd5f3ff.svg";